import { render, staticRenderFns } from "./UcMeterInvoices.yaml?vue&type=template&id=b5ef7dce&component"
import script from "./UcMeterInvoices.yaml?vue&type=script&lang=ts&component"
export * from "./UcMeterInvoices.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports